<template>
  <div>
    <simple-toolbar />
    <md-content>
      <md-table>
        <md-table-row>
          <md-table-cell style="width: 150px">{{ L('seq') }}</md-table-cell>
          <md-table-cell>{{ user.seq }}</md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>{{ L('name') }}</md-table-cell>
          <md-table-cell>{{ user.name }}</md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>{{ L('email') }}</md-table-cell>
          <md-table-cell>{{ user.email }}</md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>{{ L('avatar') }}</md-table-cell>
          <md-table-cell>
            <img :src="user.picture" />
          </md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>{{ L('joinedDate') }}</md-table-cell>
          <md-table-cell>{{
            user.created_at | moment_format('YYYY-MM-DD HH:mm')
          }}</md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>{{ L('updatedDate') }}</md-table-cell>
          <md-table-cell>{{
            user.updated_at | moment_format('YYYY-MM-DD HH:mm')
          }}</md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>{{ L('groups') }}</md-table-cell>
          <md-table-cell>
            <md-chips
              v-model="user.groups"
              class="md-dense"
              md-static
              md-dense
            />
          </md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>{{ L('roles') }}</md-table-cell>
          <md-table-cell>
            <md-chips
              v-model="user.roles"
              class="md-dense"
              md-static
              md-dense
            />
          </md-table-cell>
        </md-table-row>
      </md-table>
    </md-content>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SimpleToolbar from '@/views/layout/SimpleToolbar'
import api from '@/api'

export default {
  components: { SimpleToolbar },
  data: () => ({
    item: {
      seq: 0,
      name: '',
      avartar: '',
    },
    groups: [],
    roles: [],
  }),
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    user() {
      return this.item
    },
  },
  watch: {
    userInfo() {
      this.load()
    },
  },
  mounted() {
    if (this.userInfo.seq !== undefined) {
      this.load()
    }
  },
  methods: {
    L(path) {
      return this.$t(`personal.profile.${path}`)
    },
    async load() {
      const response = await api.session.me()
      // Ensure item is always an object to avoid runtime errors
      this.item = response || {}
      const groupNames = Array.isArray(this.item.group_names)
        ? this.item.group_names
        : []
      const roleNames = Array.isArray(this.item.role_names)
        ? this.item.role_names
        : []
      this.item.groups = groupNames
      this.item.roles = roleNames
    },
  },
}
</script>

<style lang="scss" scoped>
.md-content {
  height: 80vh;
}
</style>
